module.exports = __webpack_public_path__ + "img/1726036230734-screenshot-1726036102184.png.6ec8743a.webp";